module.exports = "/fonts/FiraSans-ExtraBoldItalic.ttf";